import { FC, useCallback } from "react";
import { isSameDay, parseISO } from "date-fns";
import { useWatch } from "react-hook-form";

import useAvailableDates from "../../../../api/hooks/useAvailableDates/useAvailableDates.ts";
import ControlledDatePicker, { ControlledSelectProps } from "../../../ControlledInputs/ControlledDatePicker.tsx";

const TimeSelect: FC<Omit<ControlledSelectProps, "shouldDisableDate"> & { onOptionsChange?: () => void; }> = (props) => {
  const hall = useWatch({
    control: props.control,
    name: "hall",
  });
  const { availableDates, isFetching } = useAvailableDates({
    hallId: hall,
  });

  const shouldDisableDate = useCallback(
    (date: Date) => {
      if (!availableDates) return false;

      const parsedDates = availableDates.map((date) => parseISO(date.availableDate));

      for (const availableDate of parsedDates) {
        if (isSameDay(date, availableDate)) {
          return false;
        }
      }
      return true;
    },
    [availableDates],
  );

  return (
    <ControlledDatePicker key={hall} shouldDisableDate={shouldDisableDate} disabled={isFetching || !hall} {...props} />
  );
};

export default TimeSelect;
